<template id="update-card-template">
    <div id="update-card-modal" class="modal fade" role="dialog">
        <div id="update-card" class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                    <h4 class="modal-title" id="myModalLabel">Update Credit Card</h4>
                </div>
                <div class="modal-body">
                    <div class="modal-subheader">
                        <span class="text-bold">Updating: <i class="fa fa-credit-card m-l-5"></i> {{ payment_profile.card.card_type }} Card {{ payment_profile.card.number }}</span>
                    </div>
                    <div class="modal-scroll-area">
                        <ul id="add-card-errors">
                            <li v-for="error in add_errors"  class="bg-danger">
                                {{ error.text }}<br />
                            </li>
                            <li v-for="message in add_messages" class="bg-warning">
                                {{ message.text }}<br />
                            </li>
                        </ul>
                        <div class="row m-10">
                            <div class="col-sm-3">
                                <div class="fg-line form-group">
                                    <label for="first_name">First Name</label>
                                    <input v-model="payment_profile.billing_details.first_name" type="text" placeholder="required"  name="first-name" id="first-name"class="form-control required">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="fg-line form-group">
                                    <label for="last-name">Last Name</label>
                                    <input v-model="payment_profile.billing_details.last_name" type="text" placeholder="required" name="last-name" id="last-name" class="form-control required">
                                </div>
                            </div>

                        </div>
                        <div class="row m-10">
                            <div class="col-sm-4">
                                <div class="fg-line form-group">
                                    <label for="address"">Address</label>
                                    <input v-model="payment_profile.billing_details.address" type="text" placeholder="required" name="address" id="address" class="form-control required">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="fg-line form-group">
                                    <label for="city">City</label>
                                    <input v-model="payment_profile.billing_details.city" type="text" placeholder="required" name="city" id="city" class="form-control required">
                                </div>
                            </div>
                            <div id="userFormColumn1" class="col-sm-3">
                                <div class="fg-line form-group">
                                    <label for="state">State</label>
                                    <input v-model="payment_profile.billing_details.state" type="text" placeholder="required" name="state" id="state" class="form-control required">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="fg-line form-group">
                                    <label for="zip" class="text-nowrap">Zip</label>
                                    <input v-model="payment_profile.billing_details.zip" type="text" placeholder="required" name="zip" id="zip" class="form-control required">
                                </div>
                            </div>
                        </div>
                        <div class="row m-10">
                            <div class="col-sm-3">
                                <div class="fg-line form-group">
                                    <label for="number">Card Number</label>
                                    <input v-model="payment_profile.card.number" type="text" placeholder="required" id="number" name="number" class="form-control required">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="fg-line form-group">
                                    <label for="expiry">Expiry</label>
                                    <input v-model="payment_profile.card.expiration_date" type="text" id="expiry" name="expiry" placeholder="MMYY" class="form-control required">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="fg-line form-group">
                                    <label for="cvc">CVC</label>
                                    <input v-model="payment_profile.card.card_code" type="text" placeholder="required" id="cvc" name="cvc" class="form-control required">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-lg btn-pdf" data-dismiss="modal"><i class="fa fa-times"></i> Close</button>
                    <button @click="save" type="button" class="btn btn-lg btn-primary" ><i class="fa fa-check"></i> Save</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">

    @import '../../sass/_global_variables.scss';

</style>
<script type="text/ecmascript-6">
    export default{
        props: ['payment_profile'],
        data(){
            return{
                add_errors: {},
                add_messages: {}
            }
        },
        methods: {

            save(){
                // Save the update
                // TODO: Build a proper expiration date


                // TODO: Maybe more validation on the card

                if( ! (this.payment_profile.card.number.toString().length > 7 && this.payment_profile.card.number.toString().length < 17 ) ){
                    sweetAlert("Error!", "Your credit card number does not look correct.", "warning");
                }if( this.payment_profile.card.expiration_date.toString().length != 4 ){
                    sweetAlert("Error!", "Your expiration does not look correct.", "warning");
                }else{

                    this.$http.post('/checkout/update-card',
                    { card: this.payment_profile })
                    .then((response) => {
                        if (response.data) {


                            // Hide our add card box
                            this.hide();

                            // Let them know the card was updated?
                            sweetAlert("Completed!", "The card has been updated.", "success");

                            // If it was successful
                            this.saved();
                        }
                    }, (response) => {
                        // error callback

                        // Show the errors and messages
                        this.add_errors = response.data.errors;
                        this.add_messages = response.data.messages;
                    });
                }


            },

            hide(){
                this.$emit('hide');
            },
            saved(){
                // Let our app know we saved the card
                this.$emit('saved');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// checkout-update-card.vue?b43f3db4